export var PriceAdjustmentBaseAmountType;
(function (PriceAdjustmentBaseAmountType) {
    PriceAdjustmentBaseAmountType[PriceAdjustmentBaseAmountType["COST"] = 1] = "COST";
    PriceAdjustmentBaseAmountType[PriceAdjustmentBaseAmountType["PRICE"] = 2] = "PRICE";
})(PriceAdjustmentBaseAmountType || (PriceAdjustmentBaseAmountType = {}));
//# sourceMappingURL=price-adjustment-base-amount-type.js.map